module.exports = __webpack_public_path__ + "img/phase1_img02.ae05183a.png";